import { AxiosError } from "axios";
import ChartLoaderView from "../../../../../common/components/molecule/Chart/ChartLoaderView/ChartLoaderView";
import { extractAxoisErrorsMessage } from "../../../../errorHandler/utils/errors.utils";
import { useConnectorData, useConnectorEnergyConsumptionData } from "../../../hooks/StationAnalysis/useConnectorAnalysis";
import { createList } from "../../../../../common/analysis/utils/graph.utils";
import BarCharView from "../../../../../common/components/molecule/Chart/BarCharView/BarCharView";
import ChartLineView from "../../../../../common/components/molecule/Chart/ChartLineView/ChartLineView";
import { MeasurandData } from "../../../types/stations.types";

export const ConnectorEnergyConsumptionChart = () => {
  const { energyConsumptionConnector, filter } =
    useConnectorEnergyConsumptionData();

  if (energyConsumptionConnector.isLoading) {
    return <ChartLoaderView />;
  }
  if (energyConsumptionConnector.isError && energyConsumptionConnector.error) {
    const error = energyConsumptionConnector.error as AxiosError;
    const message = extractAxoisErrorsMessage(error);
    if (message.includes("no data found")) {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            color: "gray",
          }}
        >
          <p>Aucune donnée trouvée</p>{" "}
        </div>
      );
    }
    return <div>Error occurred: {extractAxoisErrorsMessage(error)}</div>;
  }

  const dataChart = createList(
    filter.aggregateWindow || "1d",
    filter,
    energyConsumptionConnector.data || []
  );

  console.log("dataChart", dataChart.listValue);

  return (
    <BarCharView
      xAxisData={dataChart.listx.map((item) => new Date(item))}
      data={dataChart.listValue.map((item) => Math.round(item * 0.001))}
      label="Energy Active (kWh)"
      unit="kwh"
    />
  );
};


export default function ConnectorChart({measurand, stationId, 
    label, 
    unit, 
    convert, 
    chartType = "line"
}: { measurand: MeasurandData, stationId?: string, label?: string, unit?: string, convert?: (value: number) => number, chartType?: "line" | "bar" }) {
  const { queryData:dataQuery, filter } = useConnectorData(measurand, stationId);

  if (dataQuery.isLoading) {
    return <ChartLoaderView />;
  }
  if (dataQuery.isError && dataQuery.error) {
    const error = dataQuery.error as AxiosError;

    const message = extractAxoisErrorsMessage(error);

    if (message.includes("no data found")) {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            color: "gray",
          }}
        >
          <p>Aucune donnée trouvée</p>{" "}
        </div>
      );
    }

    return <div>Error occure {error.message}</div>;
  }

  const dataChart = createList(
    filter.aggregateWindow || "1d",
    filter,
    dataQuery.data || []
  );

  if (chartType === "line") {
    return (
      <ChartLineView
        xAxisData={dataChart.listx.map((item) => new Date(item))}
        data={dataChart.listValue.map((item) => convert ? convert(item) : item)}
        label={label}
        unit={unit}
      />
    );
  }

  if (chartType === "bar") {
       return (
      <BarCharView
        xAxisData={dataChart.listx.map((item) => new Date(item))}
        data={dataChart.listValue.map((item) => convert ? convert(item) : item)}
        label={label}
        unit={unit}
      />
    );
  }

  return (
    <BarCharView
      xAxisData={dataChart.listx.map((item) => new Date(item))}
      data={dataChart.listValue.map((item) => convert ? convert(item) : item)}
      label={label}
      unit= {unit}
    />
  );
}